import { systemBlack } from "../../../constants";
import { createStyledElement } from "../../../../../utils/createStyledElement";

const isMobileViewport = () =>
  typeof window !== "undefined" ? window.innerWidth <= 768 : false;

export const AdvantageItemContent = createStyledElement("div", () => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  gap: isMobileViewport() ? 16 : 32,
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  boxSizing: "border-box",
}));

export const AdvantageIcon = createStyledElement("img", {
  marginTop: 5,
  width: 32,
  flexShrink: 0,
});

export const AdvantageInfo = createStyledElement("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: 12,
  minWidth: 0,
  width: "100%",
});

export const Title = createStyledElement("span", () => ({
  font: isMobileViewport()
    ? '700 16px/20px "Roboto", sans-serif'
    : '700 24px/32px "Roboto", sans-serif',
  color: systemBlack,
}));

export const Subtitle = createStyledElement("span", {
  font: '400 16px/24px "Roboto", sans-serif',
  color: systemBlack,
  wordBreak: "break-word",
});
